// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b48e2ba1","690":"64c99193","984":"9927db79"}[chunkId] + ".chunk.js";
};